import NumCalculator from './NumCalculator';
import CSSCalculator from './CSSCalculator';
const genCalc = type => {
  const Calculator = type === 'css' ? CSSCalculator : NumCalculator;
  return num => new Calculator(num);
};
export default genCalc;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/theme/util/calc/index.js
// module id = 975
// module chunks = 0